export const JEWELLERY_COLLECTION_HANDLE = "jewellery";

export const JEWELLERY_GROUPS = [
  {
    id: "earrings",
    label: "Earrings",
    pattern: /\b(earrings?|hoops?)\b/i,
  },
  {
    id: "rings",
    label: "Rings",
    pattern: /\brings?\b/i,
  },
  {
    id: "necklaces",
    label: "Necklaces",
    pattern: /\bnecklaces?\b/i,
  },
  {
    id: "bracelets",
    label: "Bracelets",
    pattern: /\b(bracelets?|bangles?)\b/i,
  },
  {
    id: "belly-chains",
    label: "Belly Chains",
    pattern: /\bbelly\s+chains?\b/i,
  },
];

export function matchesJewelleryGroup(title, groupId) {
  const group = JEWELLERY_GROUPS.find((item) => item.id === groupId);

  if (!group) {
    return true;
  }

  return group.pattern.test(title || "");
}
